import Handlebars from 'handlebars';
import * as Api from '../../../../global/js/api';
import { utils } from '../../../../global/js/utils';

const NS = 'FooLibraryBlock';
const CLS = 'fooLibraryBlock';
const CLS_IS_ACTIVE = 'is-active';
const CLS_HIDE = 'd-none';
const CLS_FLEX = 'd-flex';

export class FooLibraryBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(this.element);
		this.$filter = this.$element.find(`.${CLS}-filter`);
		this.$submitBtn = this.$element.find(`.${CLS}-submitBtn`);
		this.$result = this.$element.find(`.${CLS}-result`);
		this.$resultEmpty = this.$element.find(`.${CLS}-resultEmpty`);
		this.$action = this.$element.find(`.${CLS}-action`);
		this.$pdfBtn = this.$element.find(`.${CLS}-pdfBtn`);
		this.$checkboxAll = this.$element.find(`.${CLS}-checkboxAll`);
		this.loadingSpinner = $('.loading-spinner');

		this.searchApi = this.$element.data('searchApi');
		this.pdfUrl = this.$element.data('createPdf');
		this.itemTemplate = this.renderTemplate();

		this.params = {};

		this.handleSubmitBtn();
		this.handleCheckbox();
		this.handlePdfBtn();
	}

	handleSubmitBtn() {
		this.$submitBtn.on('click', () => {
			this.updateParam();
			this.search(true);
		});
	}

	updateParam() {
		let doUpdate = (name, val) => {
			if(_.isEmpty(val)) {
				delete this.params[name];
			}
			else {
				this.params[name] = val;
			}
		};

		_.each(this.$filter.find('input[type="text"], select'), (el) => {
			let $el = $(el);
			let name = $el.attr('name');
			let val = $el.val();
			doUpdate(name, val);
		});

		// update checkbox
		let $checkbox = this.$filter.find('input[type="checkbox"]');
		let checkboxName = $checkbox.attr('name');
		let checkboxVal = [];
		_.each(this.$filter.find('input[type="checkbox"]:checked'), (el) => {
			checkboxVal.push($(el).val());
		});

		doUpdate(checkboxName, checkboxVal);
	}

	search(isReset) {
		let url = this.searchApi;

        if(!_.isEmpty(this.params)) {
            url += `?${$.param(this.params)}`;
        }

		this.loadingSpinner.addClass(CLS_IS_ACTIVE);
		this.$resultEmpty.addClass(CLS_HIDE);
		this.updateUrl();

		Api.getApi(url).then((data) => {
			if(!data) return;

			let items = data.results;

			if(items.length > 0) {
				let $lastItem = this.$result.find(`.${CLS}-item:last-child`);
				if(isReset) {
					this.$result.empty();
				}

				items.forEach((item, i) => {
					// override value if empyt string or 0
					Object.keys(item).forEach((key) => {
						if(item[key] === '') {
							item[key] = '&nbsp;';
						}
						else if(item[key] === 0) {
							item[key] = '0';
						}
					});

					// item.checkboxId = `${CLS}-item_${(this.params.pageSize * (this.params.pageNumber - 1)) + i}`;
					item.checkboxId = `${CLS}-item_${i}`;
                    let itemMarkup = this.itemTemplate(item);
                    this.$result.append(`${itemMarkup}`);
				});
				utils.scrollToEl(isReset ? this.$result : $lastItem.next(), 500);
			}
			else {
				// show empty result
				this.$result.empty();
				this.$resultEmpty.removeClass(CLS_HIDE);
			}

			// show/hide action
			if(this.$result.find(`.${CLS}-item`).length > 0) {
				this.$action.removeClass(CLS_HIDE).addClass(CLS_FLEX);
			}
			else {
				this.$action.removeClass(CLS_FLEX).addClass(CLS_HIDE);
			}

			this.loadingSpinner.removeClass(CLS_IS_ACTIVE);
		}, () => {
			this.loadingSpinner.removeClass(CLS_IS_ACTIVE);
		});
	}

	updateUrl() {
        let uri = document.location.pathname;

        Object.keys(this.params).forEach((key, index) => {
            uri = utils.updateUrlParameter(uri, key, this.params[key]);
        });

        // update url without reload
        window.history.pushState('', '', uri);
	}

	handleCheckbox() {
		this.$result.on('click', `.${CLS}-itemCheckbox`, (e) => {
			let $target = $(e.target);
			let $item = $target.closest(`.${CLS}-item`);

			if($target.is(':checked')) {
				$item.addClass(CLS_IS_ACTIVE);
			}
			else {
				$item.removeClass(CLS_IS_ACTIVE);
			}

			this.checkState();
		});

		this.$checkboxAll.on('change', () => {
			let $items = this.$result.find(`.${CLS}-item`);
			let $checkboxes = $items.find(`.${CLS}-itemCheckbox`);
			if(this.$checkboxAll.is(':checked')) {
				$checkboxes.prop('checked', true);
				$items.addClass(CLS_IS_ACTIVE);
			}
			else {
				$checkboxes.prop('checked', false);
				$items.removeClass(CLS_IS_ACTIVE);
			}
			this.checkState();
		});
	}

	handlePdfBtn() {
		this.$pdfBtn.on('click', () => {
			let uri = this.pdfUrl;
			let pdfParams = {};

			if(this.$checkboxAll.is(':checked')) {
				this.updateParam();
				pdfParams = this.params;
				pdfParams.isCheckAll = true;
			}
			else {
				let $activeItems = this.$result.find(`.${CLS}-item.${CLS_IS_ACTIVE}`);
				let selectedIds = _.map($activeItems, (obj) => {
					return obj.getAttribute('data-id');
				});
				pdfParams.id = selectedIds;
				pdfParams.isCheckAll = false;
			}

			Object.keys(pdfParams).forEach((key, index) => {
				uri = utils.updateUrlParameter(uri, key, pdfParams[key]);
			});
			window.open(uri, '_blank');
		});
	}

	checkState() {
		let totalItem = this.$result.find(`.${CLS}-item`).length;
		let totalItemActive = this.$result.find(`.${CLS}-item.${CLS_IS_ACTIVE}`).length;

		if(totalItemActive === 0) {
			this.$checkboxAll.prop('checked', false).prop('indeterminate', false);
			this.$pdfBtn.prop('disabled', true);
		}
		else if(totalItem === totalItemActive) {
			this.$checkboxAll.prop('checked', true).prop('indeterminate', false);
			this.$pdfBtn.prop('disabled', false);
		}
		else {
			this.$checkboxAll.prop('checked', false).prop('indeterminate', true);
			this.$pdfBtn.prop('disabled', false);
		}
	}

	renderTemplate() {
        let itemTemplate = require('../tmpl/fooLibraryItem.hbs');
        let rowTemplate = require('../tmpl/fooLibraryItemRow.hbs');
		Handlebars.registerPartial('fooLibraryItem', itemTemplate);
		Handlebars.registerPartial('fooLibraryItemRow', rowTemplate);

		let template = `
			{{> fooLibraryItem
				blk="fooLibraryBlock"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
    }
}
